import { Invoice } from 'types'

export type InvoicesListResponse = { data: { invoices: Invoice[] } }

interface InvoiceListParams {
  page: number
  perPage: number
  sort?: string
  dateFrom?: string
  dateTo?: string
  deadlineFrom?: string
  deadlineTo?: string
  statusFilter?: string
}

export const queryKeys = {
  invoices: {
    all: () => ['invoices'] as const,
    list: (params: InvoiceListParams) => ['invoices', params] as const,
  },
  invoice: {
    detail: (id: string | undefined) => ['invoice', id] as const,
  },
  customers: {
    search: (query: string) => ['customers', query] as const,
  },
  products: {
    search: (query: string) => ['products', query] as const,
  },
} as const
